<template>
  <div class="tracks">
    <h2 class="tracks__title mb-l">Треки конкурса</h2>
    <p class="mb-s">
      Подробную информацию о&nbsp;треках можно найти на&nbsp;<a
        href="https://konkurs.kruzhok.org/#treki"
        target="_blank"
        rel="noopener noreferrer"
        class="link"
        >лендинге конкурса кружков</a
      >.
    </p>

    <div class="tracks__warning" id="tracks">
      <BaseIcon glyph="info" width="20px" class="tracks__warning-icon" />
      <p>
        <span class="fw-700">Обратите внимание!</span>
        От&nbsp;кружка принимаем только ОДНУ заявку на&nbsp;Конкурс, выбирайте
        наиболее подходящий вам трек.
      </p>
    </div>

    <TrackPanel
      v-for="item in tracks"
      :key="item.id + 'track'"
      class="mb-s"
      :title="item.title"
      :junior="item.junior_track_id"
      :middle="item.middle_track_id"
      :senior="item.senior_track_id"
      :development="item.development"
      :interage="item.interage_track_id"
      :short="!!item.development"
      :request="request"
      :is-organizations="isOrganizations"
      :collapsible="!item.development"
      @handleRegister="handleRegister"
    />
    <div class="tracks__buttons-container">
      <BaseButton
        v-if="!user"
        tag="a"
        href="#participate"
        class="tracks__button"
        >Принять Участие</BaseButton
      >
    </div>
  </div>
</template>

<script>
import TrackPanel from "@/components/TrackPanel";
import {
  CIRCLE_DEVELOPMENT_ENVIRONMENT,
  TECHNOLOGY_JUNIOR_ID,
  TECHNOLOGY_MIDDLE_ID,
  TECHNOLOGY_SENIOR_ID,
  TECHNOLOGY_TEAM,
  TECHNOLOGY_INTERAGE_ID,
} from "@/constants";

const TRACKS = {
  technology_clubs: {
    title: "Технологические кружки",
    description:
      "Предназначен для кружков, формирующих интерес детей к&nbsp;инженерному труду, дающих опыт командного решения инженерных задач (в&nbsp;проектных командах, на&nbsp;соревнованиях и&nbsp;т.д.), обеспечивающих профессиональную навигацию для участников, в&nbsp;том числе помогающих сформировать личные профессиональные траектории, образовательные маршруты для участников в&nbsp;сферах современных технологий.",
    id: "technology_clubs",
    junior_track_id: TECHNOLOGY_JUNIOR_ID,
    middle_track_id: TECHNOLOGY_MIDDLE_ID,
    senior_track_id: TECHNOLOGY_SENIOR_ID,
    interage_track_id: TECHNOLOGY_INTERAGE_ID,
  },
  student_technology_teams: {
    title: "Студенческие технологические команды",
    description:
      "Предназначен для студенческих научных объединений, кружков на&nbsp;базе вузов и&nbsp;организаций СПО, молодежных стартапов, студенческих конструкторских бюро и&nbsp;других форм молодежных организаций, основной деятельностью которых является разработка инженерных проектов, выходящих или вышедших в&nbsp;стадию внедрения, участниками которых являются студенты вузов и&nbsp;СПО.",
    id: "student_technology_teams",
    development: TECHNOLOGY_TEAM,
  },
  circle_development_environment: {
    title: "Среда развития кружков",
    description:
      "Предназначен для организаций и&nbsp;учреждений, на&nbsp;базе которых действуют несколько технологических кружков для разных возрастных категорий учащихся, в&nbsp;которых созданы все необходимые условия для научно-технического творчества школьников и/или студентов. К&nbsp;участию в&nbsp;треке мы&nbsp;приглашаем руководителей школ, вузов, технопарков, ЦМИТов, Кванториумов и&nbsp;других организаций, которые на&nbsp;своих площадках разворачивают работу кружков. Обязательное условие участия в&nbsp;этом треке&nbsp;&mdash; на&nbsp;базе площадки работают как минимум три кружка, которые подали заявку на&nbsp;Конкурс.",
    id: "circle_development_environment",
    development: CIRCLE_DEVELOPMENT_ENVIRONMENT,
  },
};
export default {
  name: "ContestTracks",
  props: {
    user: Object,
    isOrganizations: {
      type: Boolean,
      default: false,
    },
  },
  components: { TrackPanel },
  computed: {
    tracks() {
      return TRACKS;
    },
    request() {
      return this.$store.state.requestPreparing.requests[0];
    },
  },
  methods: {
    handleRegister(id) {
      this.$emit("handleRegister", id);
    },
  },
};
</script>

<style lang="less" scoped>
.tracks {
  &__title {
    font-size: @font-size-h2;
    line-height: @line-height-h2;
    max-width: 720px;
    text-align: center;
    font-weight: 700;
    margin: 0 auto;
  }

  &__warning {
    padding: 10px;
    border: 1px solid @primary-color;
    border-radius: @border-radius-xs;
    margin-bottom: 30px;
    background-color: #fff;
    display: flex;
    gap: 10px;

    &-icon {
      color: @primary-color;
      flex-shrink: 0;
    }
  }

  &__descriptions {
    padding: 30px;
    background-color: #fff;
    border: 1px solid @blue-color;
    border-radius: @border-radius-xs;
    margin-bottom: @margin-l;

    &-box {
      margin-bottom: @margin-m;

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  &__name {
    font-size: @font-size-l;
    line-height: @line-height-l;
    font-weight: bold;
    margin-bottom: @margin-s;
  }

  &__description_italic {
    font-style: italic;
  }

  &__list {
    list-style-type: "- ";
    padding-left: 10px;
    margin-top: @margin-xs;
  }

  &__buttons-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: @margin-l;
    gap: 10px;
  }

  .link-base {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
  }

  @media (max-width: @screen-xs) {
    &__title {
      font-size: @font-size-h4;
      line-height: @line-height-h4;
    }

    &__name {
      font-size: @base-font-size;
      line-height: @base-line-height;
    }

    &__description {
      font-size: @font-size-s;
      line-height: @line-height-s;
    }
  }

  @media (max-width: @screen-xs-max) {
    .link-base:not(.link_last) {
      margin-left: @margin-l;
      margin-top: @margin-s;
    }
    &__buttons-container {
      flex-direction: column;
    }

    &__button {
      width: 100%;
    }
    &__descriptions {
      padding: 20px;
    }
  }
}
</style>
